<template>
	<loader v-if="loading || loadingSeriesAndVolumes" height="80vh" />
	<div v-else class="container ar">
		<breadcrumbs
			class="ar"
			:links="[
				{ name: $t('links.home'), link: '/' },
				{ name: $t('links.series'), link: { name: 'all-series' } },
				{
					name: serie.name,
					link: {
						name: 'serie',
						params: { id: serieId, name: serieName },
					},
				},
				{ name: volume.name, link: {}, active: true },
			]"></breadcrumbs>
		<div class="top">
			<div class="serie">
				<img :src="serie.image" alt="" />
				<span>{{ serie.name }}</span>
			</div>
			<div class="title">{{ volume.Date }} / {{ volume.name }}</div>
		</div>

		<div class="main" v-if="volume.Articles.length > 0">
			<div
				v-for="article in volume.Articles.sort((a, b) => {
					return a.order - b.order;
				})"
				:key="article">
				<router-link
					:to="{
						name: 'article',
						params: {
							id: article.id,
							name: article.name.replaceSpace(),
							serieId: serie.id,
							serieName: serie.name.replaceSpace(),
							volumeId: volume.id,
							volumeName: volume.name.replaceSpace(),
						},
					}">
					<div class="article">
						<div class="a-date" v-if="article.approved_Date">
							{{ $t('articles-page.date') }}
							{{ momentRev(article.approved_Date).format('YYYY MMMM DD') }}
						</div>
						<div class="a-title">
							{{ article.name }}
						</div>
						<div class="a-name" v-if="article.publishers_ids.length">
							<div v-for="publisher in article.publishers_ids" :key="publisher.id">
								<img
									:src="
										publisher.publisherName.image
											? publisher.publisherName.image
											: '/assets/Icons/user.png'
									"
									alt="" />
								{{ publisher.publisherName.name }}
								(
								{{ publisher.statusTitle.name }}
								)
							</div>
						</div>
					</div>
				</router-link>
			</div>
		</div>
		<div class="text-center fs-4 my-5" v-else>{{ $t('articles-page.no-data') }}</div>
	</div>
</template>

<script>
import Breadcrumbs from '@/components/Breadcrumbs';
import Loader from '@/components/Loader';
import { momentRev } from '@/helpers';
import { mapGetters } from 'vuex';
export default {
	props: ['serieId', 'serieName', 'volumeId', 'loadingSeriesAndVolumes'],

	components: {
		Breadcrumbs,
		Loader,
	},

	data() {
		return {
			volume: null,
			loading: true,
		};
	},

	computed: {
		window() {
			return window;
		},
		serie() {
			return this.getSerieById(this.serieId);
		},

		...mapGetters({
			getSerieById: 'series/getSerieById',
		}),
	},

	methods: {
		backward(arr) {
			return arr.map((e) => e).reverse();
		},
		enteri(ele) {
			const list = new IntersectionObserver((entries) => {
				entries.forEach((entry) => {
					if (entry.isIntersecting) {
						ele.classList.add('start');
					}
				});
			});
			list.observe(ele);
		},

		momentRev,
	},
	mounted() {
		Promise.all([
			this.$store.dispatch('volumes/fetchById', { id: this.volumeId }).then((data) => {
				this.volume = data;
			}),
		])
			.then(() => {
				this.loading = false;
			})
			.finally(() => {
				setTimeout(() => {
					document.querySelectorAll('.main > div').forEach((e) => {
						this.enteri(e);
					});
				}, 10);
			});
	},
};
</script>

<style scoped>
.container {
	margin-top: 50px;
}
.container > * {
	margin: 0 50px;
}
.top {
	padding: 10px 0 30px;
	border-bottom: 2px solid var(--borders-color);
}
.top > * {
	padding: 10px;
}
.serie > * {
	font-family: changeMedium;
	font-size: 15px;
}
.serie img {
	height: 30px;
	margin: 0 10px;
}
.title {
	font-size: 36px;
	font-family: changeBold;
	color: var(--green-color);
	text-align: center;
}
.main {
	padding: 20px 0 50px;
}
.main > div {
	border-bottom: 2px solid var(--borders-color);
	margin: 15px;
	padding: 30px 0;
	transform: translateX(50px);
	visibility: hidden;
	transition: 1000ms;
}
.main > div.start {
	transform: translateX(0);
	visibility: visible;
}
.main > div:last-child {
	border: none;
}
.article {
	border-radius: 5px;
}
.a-title {
	max-height: 60px;
	line-height: 30px;
	font-family: changeBold;
	margin: auto;
	font-size: 20px;
	overflow: hidden;
}
.a-name {
	font-size: 16px;
	line-height: 30px;
	font-family: changeMedium;
}
.a-name img {
	height: 20px;
	margin: 0 10px;
	border-radius: 50%;
}
.a-date {
	color: grey;
	font-size: 12px;
	line-height: 30px;
}
@media only screen and (max-width: 992px) {
	.container > * {
		margin: 0 10px;
	}
	.serie {
		text-align: center;
	}
}
@media only screen and (max-width: 768px) {
	.main > div {
		margin: 0;
	}
	.a-date {
		font-size: 12px;
	}
	.a-title {
		font-size: 18px;
	}
	.a-name {
		font-size: 14px;
		font-family: change;
	}
	.serie * {
		font-size: 13px;
	}
	.title {
		font-size: 30px;
	}
	.a-title {
		max-height: none;
	}
}
</style>
